import { generatePath, useNavigate } from 'react-router-dom';

import { ActionText } from '@components/action-text';
import { IntegrationList as CoreIntegrationList } from '@components/integrations';
import { IntegrationIcon } from '@components/integrations/common';
import { Integration } from '@components/integrations/integrations-types';
import { useScopedTranslate } from '@locale/translate';

import { routePaths } from 'ui/authenticated/navigation';

export const Integrations = () => {
  const navigate = useNavigate();
  const { t, styledTranslate } = useScopedTranslate(locale);

  return (
    <CoreIntegrationList
      breadcrumbLabel={t('customIntegrations')}
      getIntegrationUrl={(integration: Integration) =>
        generatePath(routePaths.integrationDetail, {
          integrationId: integration.shortId,
          '*': null,
        })
      }
      onIntegrationCreated={(integration: Integration) => {
        navigate(
          generatePath(routePaths.integrationDetail, {
            integrationId: integration.shortId,
            '*': null,
          }),
        );
      }}
      emptyStateContent={styledTranslate('noIntegrationsDescription', {
        action: (
          <ActionText.ExternalLink
            href="https://help.journeys.50skills.app/en/"
            color="textSecondary"
            underline
          >
            {t('aboutIntegrations')}
          </ActionText.ExternalLink>
        ),
      })}
      renderIntegrationIcon={(integration: Integration) => (
        <IntegrationIcon src={integration.thumbnail} />
      )}
    />
  );
};

const locale = {
  en: {
    customIntegrations: 'Custom integrations',
    noIntegrationsDescription:
      'Create a custom connector to connect to a REST API.\nThe API must support one of 6 authentication methods and use JSON.\n{action}',
    aboutIntegrations: 'Learn more about integrations',
  },
};
